import { search, get, post, put, remove } from '../../helpers/api';

export const AUTH_SERVICE_URI = '/offers';
export const AUTH_BASE_URI = '/api/v1/offers';

export const getOffers = async (data) =>
  search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}`, data);

export const getOfferById = async (id) =>
  get(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/${id}`);

export const createOffer = async (offer) =>
  post(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}`, offer);

export const updateOffer = async (offer) =>
  put(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/${offer.id}`, offer);

export const deleteOffer = async (offer) =>
  remove(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/${offer.id}`);
